import infoIcon from '@jetbrains/icons/info.svg?react'
import torrentIcon from '@jetbrains/icons/torrent.svg?react'
import type {IconType} from '@jetbrains/ring-ui-built/components/icon/icon'
import {IconButton} from '@jetbrains/teamcity-ui/dist/components'
import {resolveRelative} from '@jetbrains/teamcity-ui/dist/utils'
import {skipToken} from '@reduxjs/toolkit/query'
import {lazy, Suspense} from 'react'

import {restApi} from '../../../../../services/rest'
import styles from '../FileTreeNode.module.css'

const STATIC_ICONS: Record<string, IconType> = {torrent: torrentIcon, info: infoIcon}

// ponytail: ArtifactExtension.icon.name is an open server/plugin string. Core ships
// torrent + metadata statically; any other name is dynamically imported from
// @jetbrains/icons on demand (cached). A missing name renders nothing rather than crash.
const lazyIcons: Record<string, IconType> = {}
const getIcon = (name: string): IconType =>
  STATIC_ICONS[name] ??
  (lazyIcons[name] ??= lazy(() =>
    import(`@jetbrains/icons/${name}.svg?react`).catch(() => ({default: () => null})),
  ) as IconType)

type Props = {
  endpoint: string
  buildId?: number
  path: string
}

function FileTreeNodeExtension({endpoint, buildId, path}: Props) {
  const {icon, title, href} = restApi.endpoints.getArtifactExtension.useQuery(
    buildId != null ? {buildId, endpoint} : skipToken,
    {
      selectFromResult: ({data}) => {
        const {icon, title, hrefs} = data ?? {}
        return {icon: icon?.name, title, href: hrefs?.[path]}
      },
    },
  )

  return icon != null && href != null ? (
    <Suspense fallback={null}>
      <IconButton
        onClick={stop}
        className={styles.extensionIcon}
        icon={getIcon(icon)}
        title={title}
        href={resolveRelative(href)}
        target="_blank"
        rel="noreferrer"
      />
    </Suspense>
  ) : null
}

export default FileTreeNodeExtension
